// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3pP-J","inputWrap":"Table_inputWrap__S5Bzu","col":"Table_col__QwQkN","bmiTooltip":"Table_bmiTooltip__1I5-d"};